import { __assign } from '../../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import { Root, Indicator } from '../../../../../_externals/.pnpm/@radix-ui_react-checkbox@1.1.1_@types_react@18.3.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@radix-ui/react-checkbox/dist/index.js';
import { FormLabel } from '../Form.styles.js';
import '../../../../helpers/media.js';
import '../../../../helpers/animation.js';
import { generatePadding, generateBorder } from '../../../../helpers/tokens.js';

var Checkbox = styled.div({
    display: "flex",
    flexDirection: "column",
    input: {
        display: "none",
    },
});
var CheckboxLabel = styled(FormLabel)(function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return ({
        display: "flex",
        alignItems: "center",
        position: "relative",
        cursor: "pointer",
        pointerEvents: disabled ? "none" : "auto",
        color: disabled ? tokens.color.airJordan[500] : "initial",
        "&:hover": {
            "&:before": {
                borderColor: tokens.color.airJordan.p,
                svg: {
                    display: "block",
                },
            },
        },
    });
});
var CheckboxInner = styled(Root)(function (_a) {
    var checked = _a.checked, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.hasError, hasError = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? "s" : _d, checkboxType = _a.checkboxType;
    var disabledStyles = {
        border: "".concat(tokens.borderWidth.xs, " solid ").concat(tokens.color.airJordan[300]),
        background: tokens.color.airJordan[200],
    };
    var errorStyles = {
        border: "".concat(tokens.borderWidth.xs, " solid ").concat(tokens.color.roshe[600]),
        background: tokens.color.roshe[50],
    };
    return __assign(__assign(__assign(__assign(__assign({}, (checkboxType === "default" && __assign({ position: "relative", display: "flex", flexShrink: 0, marginRight: tokens.spacing[4], height: tokens.spacing[5], width: tokens.spacing[5], border: "".concat(tokens.borderWidth.xs, " solid ").concat(tokens.color.airJordan[600]), borderRadius: tokens.borderRadius.s, background: checked ? tokens.color.airJordan.p : "transparent", alignItems: "center", justifyContent: "center", padding: 0 }, (size === "l" && {
        height: "20px",
        width: "20px",
        borderRadius: tokens.borderRadius.m,
    })))), (checkboxType === "box" && __assign({ borderRadius: 0, padding: generatePadding(tokens.spacing[2], tokens.spacing[3]), background: checked ? tokens.color.airJordan.p : tokens.color.yeezy[0], border: generateBorder("xs", "solid", "airJordan.600"), width: "100%" }, (size === "l" && {
        padding: generatePadding(tokens.spacing[3], tokens.spacing[5]),
    })))), (disabled && disabledStyles)), (hasError && errorStyles)), { "&:focus-visible": {
            outline: "".concat(tokens.borderWidth.s, " solid ").concat(tokens.color.airJordan[300]),
        } });
});
var CheckboxIndicator = styled(Indicator)(function (_a) {
    var checked = _a.checked, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? "s" : _c, checkboxType = _a.checkboxType;
    var color = disabled
        ? tokens.color.airJordan[500]
        : tokens.color.yeezy[0];
    if (!checked) {
        color = disabled ? tokens.color.airJordan[400] : tokens.color.yeezy[0];
    }
    return __assign(__assign({}, (checkboxType === "default" && {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        svg: __assign({ width: "14px", height: "14px", color: color }, (size === "l" && {
            width: tokens.spacing[5],
            height: tokens.spacing[5],
        })),
    })), (checkboxType === "box" && __assign({ color: checked ? tokens.color.yeezy.p : tokens.color.airJordan.p, fontSize: tokens.fontSize[2] }, (size === "l" && {
        fontSize: tokens.fontSize[3],
    }))));
});

export { Checkbox, CheckboxIndicator, CheckboxInner, CheckboxLabel };
//# sourceMappingURL=CheckboxInput.styles.js.map
